import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';
type DeleteIconProps = Omit<BaseIconProps, 'children'>;

export const DeleteIcon = ({ ...props }: DeleteIconProps) => (
  <BaseIcon
    width={24}
    height={26}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    desc="Bin Icon"
    title="Bin Icon"
    hasLegacyStrokeStyles={true}
    {...props}
  >
    <path
      d="M2 4V17H14V4"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M0 4H16"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5 3V1H11V3"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M10 7V14"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6 7V14"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </BaseIcon>
);

DeleteIcon.displayName = 'DeleteIcon';
